import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import {
  Dialog,
  ListItem,
  ListItemText,
  Paper,
  withStyles,
  withMobileDialog,
} from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import CircularProgress from 'components/shared/CircularProgress';
import ReplyForm from './ReplyForm';
import ReviewItem from './ReviewItem';

const styles = () => ({});

const ReviewsList = ({
  isLoading,
  isUpdating,
  list,
  replyFormId,
  userId,
  sendReply,
  setReplyFormId,
  deleteReview,
  deleteReviewReply,
  editReply,
  editingReply,
  setEditingReply,
}) => {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('xs'));

  return (
    <div>
      {!isLoading && list.length === 0 && (
        <Paper>
          <ListItem>
            <ListItemText
              secondary={(
                <FormattedMessage
                  id="reviews.noReviews"
                  defaultMessage="You don't have any reviews yet"
                />
              )}
            />
          </ListItem>
        </Paper>
      )}
      {
        list.map((review, i) => (
          <ReviewItem
            key={i}
            review={review}
            {...{
              userId,
              setReplyFormId,
              deleteReviewReply,
              deleteReview,
              setEditingReply,
            }}
          />
        ))
      }
      <Dialog
        open={!!replyFormId}
        onClose={() => setReplyFormId({ id: null })}
        maxWidth="md"
        fullWidth
        fullScreen={isSmall}
      >
        <ReplyForm
          id={replyFormId}
          open={!!replyFormId}
          isUpdating={isUpdating}
          onClose={() => setReplyFormId({ id: null })}
          onSave={sendReply}
          reviewText={replyFormId && list.find(({ id }) => replyFormId === id).body}
        />
      </Dialog>
      {/* when editing a reply */}
      <Dialog
        open={!!editingReply}
        onClose={() => setEditingReply(null)}
        maxWidth="md"
        fullWidth
        fullScreen={isSmall}
      >
        <ReplyForm
          id={editingReply}
          open={!!editingReply}
          isUpdating={isUpdating}
          onClose={() => setEditingReply(null)}
          onSave={editReply}
          reviewText={editingReply && list.find(({ reply }) => editingReply === reply?.id).body}
          initialValues={{
            body: editingReply ? list.find(({ reply }) => editingReply === reply?.id).reply.body : '',
          }}
        />
      </Dialog>
      {isLoading && <CircularProgress />}
    </div>
  );
};

ReviewsList.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  isLoading: PropTypes.bool,
  isUpdating: PropTypes.bool,
  list: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  replyFormId: PropTypes.number,
  userId: PropTypes.number,

  sendReply: PropTypes.func.isRequired,
  setReplyFormId: PropTypes.func.isRequired,
  deleteReview: PropTypes.func.isRequired,
  deleteReviewReply: PropTypes.func.isRequired,
  editingReply: PropTypes.number,
  setEditingReply: PropTypes.func.isRequired,
  editReply: PropTypes.func.isRequired,
};

export default withStyles(styles)(withMobileDialog()(ReviewsList));
